module.exports = __webpack_public_path__ + "img/zhjq3_image.8e8b1304.png";